<ul class="nav nav-pills primary-navigation">
  <li class="nav-item">
    <a routerLink="/" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact: true}" class="nav-link" aria-current="page">Home</a>
  </li>
  <li class="nav-item">
    <a [routerLinkActive]="'active'" class="nav-link">Plan Your Trip</a>

    <div class="secondary-navigation bg-dark text-light d-flex justify-content-center">
      <div class="container row p-5">
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <strong>Getting To Taniti</strong>
          <ul>
            <li><a routerLink="plan/travel/air">By Air</a></li>
            <li><a routerLink="plan/travel/sea">By Sea</a></li>
          </ul>
        </div>

        <div class="col-md-3">
          <strong>Accommodations</strong>
          <ul>
            <li><a routerLink="plan/accommodations/resort">Resorts</a></li>
            <li><a routerLink="plan/accommodations/hotel">Hotels</a></li>
            <li><a routerLink="plan/accommodations/bandb">Bed &amp; Breakfast</a></li>
            <li><a routerLink="plan/accommodations/hostel">Hostels</a></li>
          </ul>
        </div>

        <div class="col-md-3">
          <strong>Ground Transporation</strong>
          <ul>
            <li><a routerLink="plan/transporation/bus">Buses</a></li>
            <li><a routerLink="plan/transporation/taxi">Taxis</a></li>
            <li><a routerLink="plan/transporation/rental">Rental Cars</a></li>
            <li><a routerLink="plan/transporation/bike">Bikes</a></li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="nav-item">
    <a [routerLinkActive]="'active'" class="nav-link">Things To Do</a>

    <div class="secondary-navigation bg-dark text-light d-flex justify-content-center">
      <div class="container row p-5">
        <div class="col-md-3">
          <strong>Top Places To Visit</strong>
          <ul>
            <li><a routerLink="about/places/taniti_city">Taniti City</a></li>
            <li><a routerLink="about/places/mont_fatu">Mont Fatu Volcano</a></li>
            <li><a routerLink="about/places/rainforest">The Umazon Rainforest</a></li>
            <li><a routerLink="about/places/yellow_leaf">Yellow Leaf Bay</a></li>
          </ul>
        </div>

        <div class="col-md-3">
          <strong>Food & Dining</strong>
          <ul>
            <li><a routerLink="about/food/restaurants">Restaurants</a></li>
            <li><a routerLink="about/food/supermarket">Supermarkets</a></li>
            <li><a routerLink="about/food/groceries">Grocery Stores</a></li>
            <li><a routerLink="about/food/convenience">Convenience Stores</a></li>
            <li><a routerLink="about/food/pub_brewery">Pubs &amp; Breweries</a></li>
          </ul>
        </div>

        <div class="col-md-3">
          <strong>Activities</strong>
          <ul>
            <li><a routerLink="about/activities/snorkeling">Snorkeling</a></li>
            <li><a routerLink="about/activities/ziplining">Ziplining</a></li>
            <li><a routerLink="about/activities/museum_gallery">Museums & Galleries</a></li>
            <li><a routerLink="about/activities/entertainment">Entertainment</a></li>
          </ul>
        </div>

        <div class="col-md-3">
          <strong>Tours</strong>
          <ul>
            <li><a routerLink="about/tours/fishing">Chartered Fishing Tours</a></li>
            <li><a routerLink="about/tours/boat_bus">Boat &amp; Bus Tours</a></li>
            <li><a routerLink="about/tours/rainforest">Rainforest Hiking Tours</a></li>
            <li><a routerLink="about/tours/volcano">Volcano Tours</a></li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="nav-item">
    <a routerLink="/about/faq" [routerLinkActive]="'active'" class="nav-link">FAQs</a>
  </li>
  <li class="nav-item">
    <a routerLink="/book" [routerLinkActive]="'active'" class="nav-link">Book Now</a>
  </li>
</ul>
